const hashString = (s = "") =>
  Array.from(s).reduce((h, ch) => ((h << 5) - h + ch.charCodeAt(0)) | 0, 0);

export const pickBadgeColors = (key = "", { bgAlpha = 0.55, textAlpha = 0.95 } = {}) => {
  const h = Math.abs(hashString(key)) % 360;
  return {
    backgroundColor: `hsl(${h} 85% 92% / ${bgAlpha})`,   // lighter/transparent
    color: `hsl(${h} 35% 28% / ${textAlpha})`,           // keep readable
  };
};
